export default __webpack_public_path__ + "static/media/hero2.1a90c74f.png";